import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { Icons } from '../../../../shared/helpers/icons';
import { UserDataService } from '../../../../shared/services/userData.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { ContactsService } from '../../../../shared/services/contact.service';
import { IContact } from '../../../../shared/models/contact';
import { MaterialEquipmentService } from '../../../../shared/services/materialsEquipment.service';
import { IMaterial } from '../../../../shared/models/materials';

@Component({
  selector: 'new-materials-equipment',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    FormsModule,
    SpinnerComponent
  ],
  templateUrl: './new-materials-equipment.component.html',
  styleUrl: './new-materials-equipment.component.css'
})
export class NewMaterialsEquipmentComponent implements OnInit {
  icons = Icons;
  currentBuildingId: string | null = null;
  fullContactsList: IContact[] = [];
  contactsList: IContact[] = [];

  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<any>();

  material: IMaterial = {
    material: '',
    contact_id: 0,
    location: ''
  };

  suggestions: string[] = [
    'Blankets',
    'Emergency Communication Devices (Radios, Cell, Bullhorn, etc.)',
    'Food',
    'Medical (AED)',
    'Medical (First Aid)',
    'Medical (Medication)',
    'Medical Supplies',
    'Recovery (Counseling/Mental Health)',
    'Tools',
    'Water'
  ];

  loading: boolean = false;
  showSuggestions: boolean = false;

  constructor(
    private userDataService: UserDataService,
    private contactsService: ContactsService,
    private materialEquipmentService: MaterialEquipmentService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.loadContacts();
  }

  loadContacts(): void {
    this.loading = true;
    this.contactsService.getContacts(this.currentBuildingId!).subscribe({
      next: (response) => {
        this.loading = false;
        this.fullContactsList = response.data || [];
        this.contactsList = [...this.fullContactsList];

        if (this.contactsList.length > 0) {
          this.contactsList.sort((a, b) => a.name.localeCompare(b.name));
          // ✅ Default to first contact
          this.material.contact_id = this.contactsList[0].id;
        }
      },
      error: (error: any) => {
        this.loading = false;
        console.error('Error loading contacts:', error.message);
      }
    });
  }

  get filteredSuggestions(): string[] {
    const query = this.material.material?.toLowerCase() || '';
    return this.suggestions.filter(s => s.toLowerCase().includes(query));
  }

  selectSuggestion(value: string): void {
    this.material.material = value;
    this.showSuggestions = false;
  }

  hideSuggestions(): void {
    setTimeout(() => this.showSuggestions = false, 150);
  }

  closeModal(): void {
    this.onClose.emit();
  }

  saveNew(): void {
    if (this.material.material && this.material.location && this.currentBuildingId) {
      this.loading = true;
      console.log("Submitting material:", this.material);
      this.materialEquipmentService.createMaterial(this.currentBuildingId, this.material).subscribe({
        next: (res) => {
          this.loading = false;
          if (!res.has_error) {
            this.onSave.emit({ type: 'success', message: 'This occurred after creating new material.' });
          }
        },
        error: (err) => {
          this.loading = false;
          this.onSave.emit({ type: 'unsuccess', message: err.message });
        }
      })
    }
  }
}
